import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppCheckErrorService } from '_services/app-check-error.service';
import { ShellLayoutService } from '_services/shell-layout.service';
import { UnivPrefsService } from '_services/univ-prefs.service';
import { SharedModule } from '_shared/shared.module';
import { DisclaimerFooterComponent } from './disclaimer-footer.component';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.css'],
  standalone: true,
  imports: [RouterModule, SharedModule, DisclaimerFooterComponent],
})
export class ShellComponent {
  readonly shell = inject(ShellLayoutService);
  readonly ups = inject(UnivPrefsService);
  readonly appCheckErrorService = inject(AppCheckErrorService);

  onDeactivate() {
    window.scrollTo(0, 0);
  }
}
